import * as styles from "./MeterIndicator.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Meter as BaseMeter } from "@base-ui/react/meter";

import type { MeterIndicatorProps } from "./Meter.types";

export function MeterIndicator({
  className,
  ...props
}: MeterIndicatorProps): JSX.Element {
  return (
    <BaseMeter.Indicator
      data-slot="meter-indicator"
      className={clsx(styles.indicator, className)}
      {...props}
    />
  );
}
